export const KEY_CODES = {
    SPACEBAR: [0, 32],
    ENTER: 13,
    DOWN_ARROW: 40,
    UP_ARROW: 38,
    ESCAPE: 27
};
